export const environment = {
    apiUrl: 'https://dev-api.mapsy.com.hr',
    tokenRefreshOffsetSeconds: 30,
};
